import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pin"
export default class extends Controller {
  static targets = ["digit", "hiddenInput"]

  connect() {
    this.digitTargets.forEach((input, index) => {
      input.addEventListener("input", () => {
        input.value = input.value.replace(/\D/, ""); // allow only digits

        if (input.value.length === 1 && index < this.digitTargets.length - 1) {
          this.digitTargets[index + 1].focus()
        }

        this.updateHiddenInput()
      })

      input.addEventListener("keydown", (event) => {
        if (event.key === "Backspace" && input.value === "" && index > 0) {
          this.digitTargets[index - 1].focus()
        }
      })
    })
  }

  updateHiddenInput() {
    const combined = this.digitTargets.map(input => input.value).join("")
    this.hiddenInputTarget.value = combined
  }
}
